import type { IntervalExpression } from '@trackback/widgets';
import { createSimpleNamedObservableExpressionResolver } from '../types';
import { interval } from 'rxjs';

export const intervalResolver =
  createSimpleNamedObservableExpressionResolver<IntervalExpression>(
    'interval',
    interval
  );
